import { useEffect, useState } from "react";

import FollowUpMaps from "../../gpa_maps/FollowUpMaps";
import InfoWrappedMaps from "../../gpa_maps/InfoWrappedMaps";
import { getFnFpError } from "@utils";
import { useTranslation } from "react-i18next";

export default function FollowUpSection(props) {
  const { t } = useTranslation();
  const [test, setTest] = useState(null);
  const [eye, setEye] = useState(null);
  const [type, setType] = useState(null);
  const [meanPsd, setMeanPsd] = useState(0);
  const [meanDeviation, setMeanDeviation] = useState(0);
  const [npdGs, setNpdGs] = useState([]);
  const [vfi, setVfi] = useState(0);
  const [ght, setGht] = useState("");
  const [ready, setReady] = useState(false);
  const [progressionStatusText, setProgressionStatusText] = useState("");

  useEffect(() => {
    if (!props.test) return;
    setTest(props.test);
    setEye(props.test?.eye ?? null);
    setType(props.test?.testType ?? null);
  }, [props.test]);

  useEffect(() => {
    if (!test) return;
    setNpdGs(test.npdGs);
    setMeanDeviation(test.md);
    setMeanPsd(test.psd);
    setVfi(test.vfi);
    setGht(test.ght);
    setReady(true);
  }, [test]);

  useEffect(() => {
    if (!props.deviationProbability) return;
    const countThrees = props.deviationProbability.filter((value) => value === 3).length;
    const countTwos = props.deviationProbability.filter((value) => value === 2).length;
    const countOnes = props.deviationProbability.filter((value) => value === 1).length;
    if (countThrees >= 3) {
      setProgressionStatusText("Likely Progression");
    } else if (countTwos + countOnes >= 3) {
      setProgressionStatusText("Possible Progression");
    } else {
      setProgressionStatusText("No progression");
    }
  }, [props.deviationProbability]);

  return (
    ready && (
      <InfoWrappedMaps
        date={new Date(test.startDate).toDateString()}
        behaviour={t("TestController.testBehaviour_" + test.testBehaviour)}
        lowReliability={false}
        vfi={vfi}
        psd={meanPsd}
        md={meanDeviation}
        progressionStatusText={progressionStatusText}
        fl={
          test.blindSpotTotal
            ? `${Number(test["blindSpotSeen"])}/${Number(test["blindSpotTotal"])}`
            : ""
        }
        ght={ght}
        fovea={test.fovea}
        fp={getFnFpError(test, "fp")}
        fn={getFnFpError(test, "fn")}
      >
        <FollowUpMaps
          type={type}
          eye={eye}
          thresholds={test.thresholds}
          npdGs={npdGs}
          deviation={props.deviation}
          progressionAnalysis={props.deviationProbability}
        />
      </InfoWrappedMaps>
    )
  );
}
